__turbopack_context__.v({
  "projectGrid": "ProjectGrid-module-scss-module__Vuo5mW__projectGrid",
  "projectRow": "ProjectGrid-module-scss-module__Vuo5mW__projectRow",
  "projectRowItem": "ProjectGrid-module-scss-module__Vuo5mW__projectRowItem",
  "projectsMobile": "ProjectGrid-module-scss-module__Vuo5mW__projectsMobile",
  "threeProjectRow": "ProjectGrid-module-scss-module__Vuo5mW__threeProjectRow",
  "twoProjectRow": "ProjectGrid-module-scss-module__Vuo5mW__twoProjectRow",
});
